import { AccessorialCode, Money } from '@rygen/rygen-ui/model';
import { ICostAllocationLineItem } from '@rygen/rygen-ui/model/costAllocation';

import { BillingShipmentLineItem } from './BillingShipmentLineItem';
import { ShipmentRateSourceInvoiceLineItem } from './ShipmentRateSourceInvoiceLineItem';

export class ShipmentRateLineItemAllocation implements ICostAllocationLineItem<ShipmentRateSourceInvoiceLineItem> {
  invoiceLineItem?: ShipmentRateSourceInvoiceLineItem;
  shipmentLineItem?: BillingShipmentLineItem;
  chargeCode?: AccessorialCode;
  amount?: Money;
  overridden: boolean = false;
  excluded: boolean = false;

  constructor(opts?: Partial<ShipmentRateLineItemAllocation>) {
    if (opts?.invoiceLineItem != null) {
      this.invoiceLineItem = new ShipmentRateSourceInvoiceLineItem(
        opts.invoiceLineItem,
      );
    }
    if (opts?.shipmentLineItem != null) {
      this.shipmentLineItem = new BillingShipmentLineItem(
        opts.shipmentLineItem,
      );
    }
    if (opts?.chargeCode != null) {
      this.chargeCode = new AccessorialCode(opts.chargeCode);
    }
    if (opts?.amount != null) {
      this.amount = new Money(opts.amount);
    }
    if (opts?.overridden != null) {
      this.overridden = opts.overridden;
    }
    if (opts?.excluded != null) {
      this.excluded = opts.excluded;
    }
  }

  get isCostEstimateInvoiceType() {
    return this.invoiceLineItem?.invoiceType === 'COST_ESTIMATE';
  }

  createLineItemAllocationInstance(): ICostAllocationLineItem<ShipmentRateSourceInvoiceLineItem> {
    return new ShipmentRateLineItemAllocation(this);
  }
}
